export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/message-text-square.445ca66a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};